export default __webpack_public_path__ + "static/media/message_pop_bg.181197b2.png";